export const PDF_TYPE = {
    SPEC: "spec",
    DOC: "doc"
}